/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { KickHandAndMachineBendFamilyInformation } from '../../components/add-family-information/kick-hand-and-machine-bend-family-information/kick-hand-and-machine-bend-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class KickHandAndMachineBendFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = KickHandAndMachineBendFamilyInformation;
    sysquePopupConfig.width = 1280;
      sysquePopupConfig.height = 765;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}